import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';

import { useAccount } from 'wagmi';
import { WEB3_HTTP_INSTANCES_BY_CHAIN } from 'context/url_based_context';

const emptyUserBalance = { wei: 0, ether: 0 };

function GetDeepComparedBalance(oldBalance, newBalance) {
  if (!oldBalance)
    return newBalance;
  else if (oldBalance.wei === newBalance.wei && oldBalance.ether === newBalance.ether)
    return oldBalance;
  else
    return newBalance;
}


function useUserBalance() {
  const userAcc = useAccount();

  const { data: userBalance } = useQuery({
    queryKey: ['userBalance', userAcc?.address, userAcc?.chainId],
    queryFn: FetchBalance,
    placeholderData: emptyUserBalance,
    refetchInterval: 5 * 1000,
    staleTime: 60 * 1000,
    structuralSharing: GetDeepComparedBalance
  });


  async function FetchBalance() {
    if (userAcc?.address) {
      const web3 = WEB3_HTTP_INSTANCES_BY_CHAIN[userAcc.chain.name]
      const balanceWei = await web3.eth.getBalance(userAcc.address);
      const balanceEther = web3.utils.fromWei(balanceWei, 'Ether')
      return { wei: balanceWei, ether: balanceEther };
    } else {
      return emptyUserBalance;
    }
  }


  return userBalance;
};

export default useUserBalance;
